import PropTypes from 'prop-types'
import React from 'react'
import classes from './Users.scss'
import Button from 'components/Button'
import List from 'components/List'

export const Users = (props) => {
  const data = props.users.map((user, index) => ({
    link: `/users/${user.id}/edit`,
    data: [
      user.email,
      user.customers && user.customers.length || null
    ]
  }))
  const headers = [
    'email',
    'customers'
  ]

  return (
    <div className={classes['collection']}>
      <header className={classes['header']}>
        <div className={classes['header-title']}>
          Browsing Users
          <span className={classes['header-title--unimportant']}> – {props.users.length}</span>
        </div>

        <div className={classes['header-buttons']}>
          <Button options={['green', 'small']} element='a' href='/users/new'>
            Add User
          </Button>
        </div>
      </header>

      <List data={data} headers={headers} />
    </div>
  )
}

Users.propTypes = {
  users: PropTypes.array.isRequired
}

Users.defaultProps = {
  users: []
}

export default Users



// WEBPACK FOOTER //
// ./src/components/Users/Users.js